import React from 'react'
import * as classes from './wbbutton.module.scss'
import { Link } from "gatsby"

export default function WBButton(props) {
    let button = (
        <Link 
            to={props.to} 
            className={classes.Btn + " " + classes.BtnPrimary}>{props.text}
        </Link>
    );

    if (props.external) {
        button = (
            <a 
                href={props.to} 
                target="_blank"
                rel="noreferrer"
                className={classes.Btn + " " + classes.BtnPrimary}>{props.text}
            </a>
        )
    }

    return button;
}